import { DataPrivacyParams, useDataPrivacy } from './useDataPrivacy';
import { core } from '@tock/coretypes';
import { useState } from 'react';

export interface MarketingOptInResults {
  softOptIn: boolean;
  setSoftOptIn: (value: boolean) => void;
  showSoftOptInCheckbox: boolean;
  marketingOptInStatus: core.MarketingOptInStatus;
}

export default (params?: DataPrivacyParams): MarketingOptInResults => {
  /**
   * "Soft Opt in" == Opting out
   */
  const [softOptIn, setSoftOptIn] = useState(false);
  const { showSoftOptInCheckbox } = useDataPrivacy(params);

  return {
    softOptIn: softOptIn,
    setSoftOptIn: setSoftOptIn,
    showSoftOptInCheckbox: showSoftOptInCheckbox,
    marketingOptInStatus: showSoftOptInCheckbox
      ? softOptIn
        ? 'OPTED_OUT'
        : 'OPTED_IN'
      : 'AUTO_OPTED_IN',
  };
};
